/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * MessageQueue API Specification
 * OpenAPI spec version: 0.0.7
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { computed, unref } from 'vue';
import type { MaybeRef } from 'vue';

import type {
  ApiResponseResponseWithColumnKafkaListDto,
  GetV8MessageQueueKafkaDetailFunctionParams,
  GetV8MessageQueueKafkaInfoByKafkaInstanceTypeAndKafkaInstanceIdParams,
  GetV8MessageQueueKafkaParams,
  KafKaTopicMessageRequest,
  KafKaTopicPartitionRequest,
  KafkaBrokerListResponse,
  KafkaConsumerGroupListResponse,
  KafkaDetailFunctionResponse,
  KafkaInfoResponse,
  KafkaTopicListResponse,
  KafkaTopicMessageResponse,
  KafkaTopicPartitionResponse,
} from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType, BodyType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary getKafkaList
 */
export const getV8MessageQueueKafka = (
  params: MaybeRef<GetV8MessageQueueKafkaParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<ApiResponseResponseWithColumnKafkaListDto>(
    { url: `/api/v8/message-queue/kafka`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV8MessageQueueKafkaQueryKey = (
  params?: MaybeRef<GetV8MessageQueueKafkaParams>,
) => {
  return ['api', 'v8', 'message-queue', 'kafka', ...(params ? [params] : [])] as const;
};

export const getGetV8MessageQueueKafkaQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8MessageQueueKafka>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV8MessageQueueKafkaParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8MessageQueueKafka>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8MessageQueueKafkaQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV8MessageQueueKafka>>> = ({ signal }) =>
    getV8MessageQueueKafka(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV8MessageQueueKafka>>,
    TError,
    TData
  >;
};

export type GetV8MessageQueueKafkaQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV8MessageQueueKafka>>
>;
export type GetV8MessageQueueKafkaQueryError = ErrorType<unknown>;

/**
 * @summary getKafkaList
 */

export function useGetV8MessageQueueKafka<
  TData = Awaited<ReturnType<typeof getV8MessageQueueKafka>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV8MessageQueueKafkaParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8MessageQueueKafka>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8MessageQueueKafkaQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary getKafkaDetailFunction
 */
export const getV8MessageQueueKafkaDetailFunction = (
  params: MaybeRef<GetV8MessageQueueKafkaDetailFunctionParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<KafkaDetailFunctionResponse>(
    {
      url: `/api/v8/message-queue/kafka/detail-function`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV8MessageQueueKafkaDetailFunctionQueryKey = (
  params?: MaybeRef<GetV8MessageQueueKafkaDetailFunctionParams>,
) => {
  return [
    'api',
    'v8',
    'message-queue',
    'kafka',
    'detail-function',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV8MessageQueueKafkaDetailFunctionQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8MessageQueueKafkaDetailFunction>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV8MessageQueueKafkaDetailFunctionParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV8MessageQueueKafkaDetailFunction>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8MessageQueueKafkaDetailFunctionQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV8MessageQueueKafkaDetailFunction>>
  > = ({ signal }) => getV8MessageQueueKafkaDetailFunction(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV8MessageQueueKafkaDetailFunction>>,
    TError,
    TData
  >;
};

export type GetV8MessageQueueKafkaDetailFunctionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV8MessageQueueKafkaDetailFunction>>
>;
export type GetV8MessageQueueKafkaDetailFunctionQueryError = ErrorType<unknown>;

/**
 * @summary getKafkaDetailFunction
 */

export function useGetV8MessageQueueKafkaDetailFunction<
  TData = Awaited<ReturnType<typeof getV8MessageQueueKafkaDetailFunction>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV8MessageQueueKafkaDetailFunctionParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV8MessageQueueKafkaDetailFunction>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8MessageQueueKafkaDetailFunctionQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary getKafkaBrokerList
 */
export const getV8MessageQueueKafkaBrokerByKafkaInstanceTypeAndKafkaInstanceId = (
  kafkaInstanceType: MaybeRef<'broker' | 'cluster' | 'topic'>,
  kafkaInstanceId: MaybeRef<string>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  kafkaInstanceType = unref(kafkaInstanceType);
  kafkaInstanceId = unref(kafkaInstanceId);

  return customAxiosInstance<KafkaBrokerListResponse>(
    {
      url: `/api/v8/message-queue/kafka/${kafkaInstanceType}/${kafkaInstanceId}/broker`,
      method: 'GET',
      signal,
    },
    options,
  );
};

export const getGetV8MessageQueueKafkaBrokerByKafkaInstanceTypeAndKafkaInstanceIdQueryKey = (
  kafkaInstanceType?: MaybeRef<'broker' | 'cluster' | 'topic'>,
  kafkaInstanceId?: MaybeRef<string>,
) => {
  return [
    'api',
    'v8',
    'message-queue',
    'kafka',
    kafkaInstanceType,
    kafkaInstanceId,
    'broker',
  ] as const;
};

export const getGetV8MessageQueueKafkaBrokerByKafkaInstanceTypeAndKafkaInstanceIdQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getV8MessageQueueKafkaBrokerByKafkaInstanceTypeAndKafkaInstanceId>
  >,
  TError = ErrorType<unknown>,
>(
  kafkaInstanceType: MaybeRef<'broker' | 'cluster' | 'topic'>,
  kafkaInstanceId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getV8MessageQueueKafkaBrokerByKafkaInstanceTypeAndKafkaInstanceId>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8MessageQueueKafkaBrokerByKafkaInstanceTypeAndKafkaInstanceIdQueryKey(
    kafkaInstanceType,
    kafkaInstanceId,
  );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV8MessageQueueKafkaBrokerByKafkaInstanceTypeAndKafkaInstanceId>>
  > = ({ signal }) =>
    getV8MessageQueueKafkaBrokerByKafkaInstanceTypeAndKafkaInstanceId(
      kafkaInstanceType,
      kafkaInstanceId,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!(unref(kafkaInstanceType) && unref(kafkaInstanceId))),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV8MessageQueueKafkaBrokerByKafkaInstanceTypeAndKafkaInstanceId>>,
    TError,
    TData
  >;
};

export type GetV8MessageQueueKafkaBrokerByKafkaInstanceTypeAndKafkaInstanceIdQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getV8MessageQueueKafkaBrokerByKafkaInstanceTypeAndKafkaInstanceId>>
  >;
export type GetV8MessageQueueKafkaBrokerByKafkaInstanceTypeAndKafkaInstanceIdQueryError =
  ErrorType<unknown>;

/**
 * @summary getKafkaBrokerList
 */

export function useGetV8MessageQueueKafkaBrokerByKafkaInstanceTypeAndKafkaInstanceId<
  TData = Awaited<
    ReturnType<typeof getV8MessageQueueKafkaBrokerByKafkaInstanceTypeAndKafkaInstanceId>
  >,
  TError = ErrorType<unknown>,
>(
  kafkaInstanceType: MaybeRef<'broker' | 'cluster' | 'topic'>,
  kafkaInstanceId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getV8MessageQueueKafkaBrokerByKafkaInstanceTypeAndKafkaInstanceId>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions =
    getGetV8MessageQueueKafkaBrokerByKafkaInstanceTypeAndKafkaInstanceIdQueryOptions(
      kafkaInstanceType,
      kafkaInstanceId,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary getKafkaConsumerGroupList
 */
export const getV8MessageQueueKafkaConsumerGroupByKafkaInstanceTypeAndKafkaInstanceId = (
  kafkaInstanceType: MaybeRef<'broker' | 'cluster' | 'topic'>,
  kafkaInstanceId: MaybeRef<string>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  kafkaInstanceType = unref(kafkaInstanceType);
  kafkaInstanceId = unref(kafkaInstanceId);

  return customAxiosInstance<KafkaConsumerGroupListResponse>(
    {
      url: `/api/v8/message-queue/kafka/${kafkaInstanceType}/${kafkaInstanceId}/consumer-group`,
      method: 'GET',
      signal,
    },
    options,
  );
};

export const getGetV8MessageQueueKafkaConsumerGroupByKafkaInstanceTypeAndKafkaInstanceIdQueryKey = (
  kafkaInstanceType?: MaybeRef<'broker' | 'cluster' | 'topic'>,
  kafkaInstanceId?: MaybeRef<string>,
) => {
  return [
    'api',
    'v8',
    'message-queue',
    'kafka',
    kafkaInstanceType,
    kafkaInstanceId,
    'consumer-group',
  ] as const;
};

export const getGetV8MessageQueueKafkaConsumerGroupByKafkaInstanceTypeAndKafkaInstanceIdQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getV8MessageQueueKafkaConsumerGroupByKafkaInstanceTypeAndKafkaInstanceId>
    >,
    TError = ErrorType<unknown>,
  >(
    kafkaInstanceType: MaybeRef<'broker' | 'cluster' | 'topic'>,
    kafkaInstanceId: MaybeRef<string>,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getV8MessageQueueKafkaConsumerGroupByKafkaInstanceTypeAndKafkaInstanceId
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof customAxiosInstance>;
    },
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      getGetV8MessageQueueKafkaConsumerGroupByKafkaInstanceTypeAndKafkaInstanceIdQueryKey(
        kafkaInstanceType,
        kafkaInstanceId,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getV8MessageQueueKafkaConsumerGroupByKafkaInstanceTypeAndKafkaInstanceId>
      >
    > = ({ signal }) =>
      getV8MessageQueueKafkaConsumerGroupByKafkaInstanceTypeAndKafkaInstanceId(
        kafkaInstanceType,
        kafkaInstanceId,
        requestOptions,
        signal,
      );

    return {
      queryKey,
      queryFn,
      enabled: computed(() => !!(unref(kafkaInstanceType) && unref(kafkaInstanceId))),
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getV8MessageQueueKafkaConsumerGroupByKafkaInstanceTypeAndKafkaInstanceId>
      >,
      TError,
      TData
    >;
  };

export type GetV8MessageQueueKafkaConsumerGroupByKafkaInstanceTypeAndKafkaInstanceIdQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getV8MessageQueueKafkaConsumerGroupByKafkaInstanceTypeAndKafkaInstanceId>
    >
  >;
export type GetV8MessageQueueKafkaConsumerGroupByKafkaInstanceTypeAndKafkaInstanceIdQueryError =
  ErrorType<unknown>;

/**
 * @summary getKafkaConsumerGroupList
 */

export function useGetV8MessageQueueKafkaConsumerGroupByKafkaInstanceTypeAndKafkaInstanceId<
  TData = Awaited<
    ReturnType<typeof getV8MessageQueueKafkaConsumerGroupByKafkaInstanceTypeAndKafkaInstanceId>
  >,
  TError = ErrorType<unknown>,
>(
  kafkaInstanceType: MaybeRef<'broker' | 'cluster' | 'topic'>,
  kafkaInstanceId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getV8MessageQueueKafkaConsumerGroupByKafkaInstanceTypeAndKafkaInstanceId
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions =
    getGetV8MessageQueueKafkaConsumerGroupByKafkaInstanceTypeAndKafkaInstanceIdQueryOptions(
      kafkaInstanceType,
      kafkaInstanceId,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary getKafkaInstanceInfo
 */
export const getV8MessageQueueKafkaInfoByKafkaInstanceTypeAndKafkaInstanceId = (
  kafkaInstanceType: MaybeRef<'broker' | 'cluster' | 'topic'>,
  kafkaInstanceId: MaybeRef<string>,
  params?: MaybeRef<GetV8MessageQueueKafkaInfoByKafkaInstanceTypeAndKafkaInstanceIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  kafkaInstanceType = unref(kafkaInstanceType);
  kafkaInstanceId = unref(kafkaInstanceId);
  params = unref(params);

  return customAxiosInstance<KafkaInfoResponse>(
    {
      url: `/api/v8/message-queue/kafka/${kafkaInstanceType}/${kafkaInstanceId}/info`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV8MessageQueueKafkaInfoByKafkaInstanceTypeAndKafkaInstanceIdQueryKey = (
  kafkaInstanceType?: MaybeRef<'broker' | 'cluster' | 'topic'>,
  kafkaInstanceId?: MaybeRef<string>,
  params?: MaybeRef<GetV8MessageQueueKafkaInfoByKafkaInstanceTypeAndKafkaInstanceIdParams>,
) => {
  return [
    'api',
    'v8',
    'message-queue',
    'kafka',
    kafkaInstanceType,
    kafkaInstanceId,
    'info',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV8MessageQueueKafkaInfoByKafkaInstanceTypeAndKafkaInstanceIdQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getV8MessageQueueKafkaInfoByKafkaInstanceTypeAndKafkaInstanceId>
  >,
  TError = ErrorType<unknown>,
>(
  kafkaInstanceType: MaybeRef<'broker' | 'cluster' | 'topic'>,
  kafkaInstanceId: MaybeRef<string>,
  params?: MaybeRef<GetV8MessageQueueKafkaInfoByKafkaInstanceTypeAndKafkaInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV8MessageQueueKafkaInfoByKafkaInstanceTypeAndKafkaInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8MessageQueueKafkaInfoByKafkaInstanceTypeAndKafkaInstanceIdQueryKey(
    kafkaInstanceType,
    kafkaInstanceId,
    params,
  );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV8MessageQueueKafkaInfoByKafkaInstanceTypeAndKafkaInstanceId>>
  > = ({ signal }) =>
    getV8MessageQueueKafkaInfoByKafkaInstanceTypeAndKafkaInstanceId(
      kafkaInstanceType,
      kafkaInstanceId,
      params,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!(unref(kafkaInstanceType) && unref(kafkaInstanceId))),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV8MessageQueueKafkaInfoByKafkaInstanceTypeAndKafkaInstanceId>>,
    TError,
    TData
  >;
};

export type GetV8MessageQueueKafkaInfoByKafkaInstanceTypeAndKafkaInstanceIdQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getV8MessageQueueKafkaInfoByKafkaInstanceTypeAndKafkaInstanceId>>
  >;
export type GetV8MessageQueueKafkaInfoByKafkaInstanceTypeAndKafkaInstanceIdQueryError =
  ErrorType<unknown>;

/**
 * @summary getKafkaInstanceInfo
 */

export function useGetV8MessageQueueKafkaInfoByKafkaInstanceTypeAndKafkaInstanceId<
  TData = Awaited<
    ReturnType<typeof getV8MessageQueueKafkaInfoByKafkaInstanceTypeAndKafkaInstanceId>
  >,
  TError = ErrorType<unknown>,
>(
  kafkaInstanceType: MaybeRef<'broker' | 'cluster' | 'topic'>,
  kafkaInstanceId: MaybeRef<string>,
  params?: MaybeRef<GetV8MessageQueueKafkaInfoByKafkaInstanceTypeAndKafkaInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV8MessageQueueKafkaInfoByKafkaInstanceTypeAndKafkaInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions =
    getGetV8MessageQueueKafkaInfoByKafkaInstanceTypeAndKafkaInstanceIdQueryOptions(
      kafkaInstanceType,
      kafkaInstanceId,
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary getKafkaTopicList
 */
export const getV8MessageQueueKafkaTopicByKafkaInstanceTypeAndKafkaInstanceId = (
  kafkaInstanceType: MaybeRef<'broker' | 'cluster' | 'topic'>,
  kafkaInstanceId: MaybeRef<string>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  kafkaInstanceType = unref(kafkaInstanceType);
  kafkaInstanceId = unref(kafkaInstanceId);

  return customAxiosInstance<KafkaTopicListResponse>(
    {
      url: `/api/v8/message-queue/kafka/${kafkaInstanceType}/${kafkaInstanceId}/topic`,
      method: 'GET',
      signal,
    },
    options,
  );
};

export const getGetV8MessageQueueKafkaTopicByKafkaInstanceTypeAndKafkaInstanceIdQueryKey = (
  kafkaInstanceType?: MaybeRef<'broker' | 'cluster' | 'topic'>,
  kafkaInstanceId?: MaybeRef<string>,
) => {
  return [
    'api',
    'v8',
    'message-queue',
    'kafka',
    kafkaInstanceType,
    kafkaInstanceId,
    'topic',
  ] as const;
};

export const getGetV8MessageQueueKafkaTopicByKafkaInstanceTypeAndKafkaInstanceIdQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getV8MessageQueueKafkaTopicByKafkaInstanceTypeAndKafkaInstanceId>
  >,
  TError = ErrorType<unknown>,
>(
  kafkaInstanceType: MaybeRef<'broker' | 'cluster' | 'topic'>,
  kafkaInstanceId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getV8MessageQueueKafkaTopicByKafkaInstanceTypeAndKafkaInstanceId>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8MessageQueueKafkaTopicByKafkaInstanceTypeAndKafkaInstanceIdQueryKey(
    kafkaInstanceType,
    kafkaInstanceId,
  );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV8MessageQueueKafkaTopicByKafkaInstanceTypeAndKafkaInstanceId>>
  > = ({ signal }) =>
    getV8MessageQueueKafkaTopicByKafkaInstanceTypeAndKafkaInstanceId(
      kafkaInstanceType,
      kafkaInstanceId,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!(unref(kafkaInstanceType) && unref(kafkaInstanceId))),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV8MessageQueueKafkaTopicByKafkaInstanceTypeAndKafkaInstanceId>>,
    TError,
    TData
  >;
};

export type GetV8MessageQueueKafkaTopicByKafkaInstanceTypeAndKafkaInstanceIdQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getV8MessageQueueKafkaTopicByKafkaInstanceTypeAndKafkaInstanceId>>
  >;
export type GetV8MessageQueueKafkaTopicByKafkaInstanceTypeAndKafkaInstanceIdQueryError =
  ErrorType<unknown>;

/**
 * @summary getKafkaTopicList
 */

export function useGetV8MessageQueueKafkaTopicByKafkaInstanceTypeAndKafkaInstanceId<
  TData = Awaited<
    ReturnType<typeof getV8MessageQueueKafkaTopicByKafkaInstanceTypeAndKafkaInstanceId>
  >,
  TError = ErrorType<unknown>,
>(
  kafkaInstanceType: MaybeRef<'broker' | 'cluster' | 'topic'>,
  kafkaInstanceId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getV8MessageQueueKafkaTopicByKafkaInstanceTypeAndKafkaInstanceId>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions =
    getGetV8MessageQueueKafkaTopicByKafkaInstanceTypeAndKafkaInstanceIdQueryOptions(
      kafkaInstanceType,
      kafkaInstanceId,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary getKafkaTopicMessage
 */
export const postV8MessageQueueKafkaTopicMessageByKafkaInstanceTypeAndKafkaInstanceId = (
  kafkaInstanceType: MaybeRef<'broker' | 'cluster' | 'topic'>,
  kafkaInstanceId: MaybeRef<string>,
  kafKaTopicMessageRequest: MaybeRef<KafKaTopicMessageRequest>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  kafkaInstanceType = unref(kafkaInstanceType);
  kafkaInstanceId = unref(kafkaInstanceId);
  kafKaTopicMessageRequest = unref(kafKaTopicMessageRequest);

  return customAxiosInstance<KafkaTopicMessageResponse>(
    {
      url: `/api/v8/message-queue/kafka/${kafkaInstanceType}/${kafkaInstanceId}/topic-message`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: kafKaTopicMessageRequest,
      signal,
    },
    options,
  );
};

export const getPostV8MessageQueueKafkaTopicMessageByKafkaInstanceTypeAndKafkaInstanceIdMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postV8MessageQueueKafkaTopicMessageByKafkaInstanceTypeAndKafkaInstanceId>
      >,
      TError,
      {
        kafkaInstanceType: 'broker' | 'cluster' | 'topic';
        kafkaInstanceId: string;
        data: BodyType<KafKaTopicMessageRequest>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postV8MessageQueueKafkaTopicMessageByKafkaInstanceTypeAndKafkaInstanceId>
    >,
    TError,
    {
      kafkaInstanceType: 'broker' | 'cluster' | 'topic';
      kafkaInstanceId: string;
      data: BodyType<KafKaTopicMessageRequest>;
    },
    TContext
  > => {
    const mutationKey = [
      'postV8MessageQueueKafkaTopicMessageByKafkaInstanceTypeAndKafkaInstanceId',
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postV8MessageQueueKafkaTopicMessageByKafkaInstanceTypeAndKafkaInstanceId>
      >,
      {
        kafkaInstanceType: 'broker' | 'cluster' | 'topic';
        kafkaInstanceId: string;
        data: BodyType<KafKaTopicMessageRequest>;
      }
    > = (props) => {
      const { kafkaInstanceType, kafkaInstanceId, data } = props ?? {};

      return postV8MessageQueueKafkaTopicMessageByKafkaInstanceTypeAndKafkaInstanceId(
        kafkaInstanceType,
        kafkaInstanceId,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostV8MessageQueueKafkaTopicMessageByKafkaInstanceTypeAndKafkaInstanceIdMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof postV8MessageQueueKafkaTopicMessageByKafkaInstanceTypeAndKafkaInstanceId>
    >
  >;
export type PostV8MessageQueueKafkaTopicMessageByKafkaInstanceTypeAndKafkaInstanceIdMutationBody =
  BodyType<KafKaTopicMessageRequest>;
export type PostV8MessageQueueKafkaTopicMessageByKafkaInstanceTypeAndKafkaInstanceIdMutationError =
  ErrorType<unknown>;

/**
 * @summary getKafkaTopicMessage
 */
export const usePostV8MessageQueueKafkaTopicMessageByKafkaInstanceTypeAndKafkaInstanceId = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postV8MessageQueueKafkaTopicMessageByKafkaInstanceTypeAndKafkaInstanceId>
      >,
      TError,
      {
        kafkaInstanceType: 'broker' | 'cluster' | 'topic';
        kafkaInstanceId: string;
        data: BodyType<KafKaTopicMessageRequest>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<
    ReturnType<typeof postV8MessageQueueKafkaTopicMessageByKafkaInstanceTypeAndKafkaInstanceId>
  >,
  TError,
  {
    kafkaInstanceType: 'broker' | 'cluster' | 'topic';
    kafkaInstanceId: string;
    data: BodyType<KafKaTopicMessageRequest>;
  },
  TContext
> => {
  const mutationOptions =
    getPostV8MessageQueueKafkaTopicMessageByKafkaInstanceTypeAndKafkaInstanceIdMutationOptions(
      options,
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary getKafkaTopicPartition
 */
export const postV8MessageQueueKafkaTopicPartitionByKafkaInstanceTypeAndKafkaInstanceId = (
  kafkaInstanceType: MaybeRef<'broker' | 'cluster' | 'topic'>,
  kafkaInstanceId: MaybeRef<string>,
  kafKaTopicPartitionRequest: MaybeRef<KafKaTopicPartitionRequest>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  kafkaInstanceType = unref(kafkaInstanceType);
  kafkaInstanceId = unref(kafkaInstanceId);
  kafKaTopicPartitionRequest = unref(kafKaTopicPartitionRequest);

  return customAxiosInstance<KafkaTopicPartitionResponse>(
    {
      url: `/api/v8/message-queue/kafka/${kafkaInstanceType}/${kafkaInstanceId}/topic-partition`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: kafKaTopicPartitionRequest,
      signal,
    },
    options,
  );
};

export const getPostV8MessageQueueKafkaTopicPartitionByKafkaInstanceTypeAndKafkaInstanceIdMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postV8MessageQueueKafkaTopicPartitionByKafkaInstanceTypeAndKafkaInstanceId
        >
      >,
      TError,
      {
        kafkaInstanceType: 'broker' | 'cluster' | 'topic';
        kafkaInstanceId: string;
        data: BodyType<KafKaTopicPartitionRequest>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postV8MessageQueueKafkaTopicPartitionByKafkaInstanceTypeAndKafkaInstanceId>
    >,
    TError,
    {
      kafkaInstanceType: 'broker' | 'cluster' | 'topic';
      kafkaInstanceId: string;
      data: BodyType<KafKaTopicPartitionRequest>;
    },
    TContext
  > => {
    const mutationKey = [
      'postV8MessageQueueKafkaTopicPartitionByKafkaInstanceTypeAndKafkaInstanceId',
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof postV8MessageQueueKafkaTopicPartitionByKafkaInstanceTypeAndKafkaInstanceId
        >
      >,
      {
        kafkaInstanceType: 'broker' | 'cluster' | 'topic';
        kafkaInstanceId: string;
        data: BodyType<KafKaTopicPartitionRequest>;
      }
    > = (props) => {
      const { kafkaInstanceType, kafkaInstanceId, data } = props ?? {};

      return postV8MessageQueueKafkaTopicPartitionByKafkaInstanceTypeAndKafkaInstanceId(
        kafkaInstanceType,
        kafkaInstanceId,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostV8MessageQueueKafkaTopicPartitionByKafkaInstanceTypeAndKafkaInstanceIdMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof postV8MessageQueueKafkaTopicPartitionByKafkaInstanceTypeAndKafkaInstanceId>
    >
  >;
export type PostV8MessageQueueKafkaTopicPartitionByKafkaInstanceTypeAndKafkaInstanceIdMutationBody =
  BodyType<KafKaTopicPartitionRequest>;
export type PostV8MessageQueueKafkaTopicPartitionByKafkaInstanceTypeAndKafkaInstanceIdMutationError =
  ErrorType<unknown>;

/**
 * @summary getKafkaTopicPartition
 */
export const usePostV8MessageQueueKafkaTopicPartitionByKafkaInstanceTypeAndKafkaInstanceId = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postV8MessageQueueKafkaTopicPartitionByKafkaInstanceTypeAndKafkaInstanceId
        >
      >,
      TError,
      {
        kafkaInstanceType: 'broker' | 'cluster' | 'topic';
        kafkaInstanceId: string;
        data: BodyType<KafKaTopicPartitionRequest>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<
    ReturnType<typeof postV8MessageQueueKafkaTopicPartitionByKafkaInstanceTypeAndKafkaInstanceId>
  >,
  TError,
  {
    kafkaInstanceType: 'broker' | 'cluster' | 'topic';
    kafkaInstanceId: string;
    data: BodyType<KafKaTopicPartitionRequest>;
  },
  TContext
> => {
  const mutationOptions =
    getPostV8MessageQueueKafkaTopicPartitionByKafkaInstanceTypeAndKafkaInstanceIdMutationOptions(
      options,
    );

  return useMutation(mutationOptions, queryClient);
};
